import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { authApiClient } from '../../../utils/axios';
import { isString } from 'lodash';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const signup = async ({ payload }) => {
  const response = await authApiClient.post('/signup', payload);
  return response.data;
};

export const useSignupHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);
  const { snackbarMessages } = useTranslatedMessages();
  const signupMessages = snackbarMessages.signup ?? {};

  const mutation = useMutation({
    mutationFn: signup,
    onSuccess: (data, variables, context) => {
      dispatch(
        showSnackbar({
          message: signupMessages.signup_success,
        }),
      );
      queryClient.invalidateQueries({ queryKey: ['auth'] });
      onSuccess && onSuccess(data);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
      } else {
        dispatch(
          showSnackbar({
            message: isString(error.message) ? error.message : JSON.stringify(error.message),
            severity: 'error',
          }),
        );
      }
    },
  });

  const onSubmit = async (payload) => {
    mutation.mutate({ payload });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
